/* eslint-disable no-undef */
import './navigation-drawer'
import './navigation-dropdown'
import './cookies'
import './dropdown-input-phone'

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

const preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="white" fill-opacity="0.2"/>
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8346 14.2283C13.2723 13.8582 14.3346 12.5532 14.3346 11C14.3346 9.15901 12.8423 7.66663 11.0013 7.66663C9.16035 7.66663 7.66797 9.15901 7.66797 11C7.66797 12.5532 8.73028 13.8582 10.168 14.2283V23.5C10.168 23.9602 10.5411 24.3333 11.0013 24.3333C11.4615 24.3333 11.8346 23.9602 11.8346 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.668 21C17.668 19.4468 18.7303 18.1417 20.168 17.7716V12.6666C20.168 12.4456 20.0802 12.2336 19.9239 12.0774C19.7676 11.9211 19.5556 11.8333 19.3346 11.8333H16.8346C16.3744 11.8333 16.0013 11.4602 16.0013 11C16.0013 10.5397 16.3744 10.1666 16.8346 10.1666H19.3346C19.9977 10.1666 20.6336 10.43 21.1024 10.8989C21.5712 11.3677 21.8346 12.0036 21.8346 12.6666V17.7716C23.2723 18.1417 24.3346 19.4468 24.3346 21C24.3346 22.8409 22.8422 24.3333 21.0013 24.3333C19.1604 24.3333 17.668 22.8409 17.668 21Z" fill="white"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7716V12.6666C20.1667 12.4456 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5397 16.3731 10.1666 16.8333 10.1666H19.3333C19.9964 10.1666 20.6323 10.43 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6666V17.7716C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="white"/>
</svg>`

document.querySelector('.contents__booking--preHeadingIcon').innerHTML +=
  preHeadingIcon

const arrowUpRightIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66602 11.3333L11.3327 4.66663M11.3327 4.66663H4.66602M11.3327 4.66663V11.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.visit-us--link').forEach((el) => {
  el.innerHTML += arrowUpRightIcon
})

const arrowIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 6L8 10L12 6" stroke="#CBD5E1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.contactUs--inputPhoneArrowIcon').innerHTML += arrowIcon

document
  .querySelector('.bookDemoForm')
  .addEventListener('submit', function (e) {
    e.preventDefault()

    Toastify({
      text: 'The book a demo submission form has been successfully sent!',
      duration: 3000,
      gravity: 'top', // `top` or `bottom`
      position: 'center', // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: '#05a6f0',
        fontFamily: '"Montserrat", sans-serif',
        fontSize: '14px',
      },
      // onClick: function () {} // Callback after click
    }).showToast()
    setTimeout(() => {
      document.querySelector('.bookDemoForm').reset()
      document.querySelector(
        '.contactUs--inputPhoneContainer .contactUs--contentEditable',
      ).textContent = ''
    }, 1500)
  })

document
  .querySelector('.contactUs--inputPhoneContainer .contactUs--contentEditable')
  .addEventListener('keypress', (e) => {
    const regex = /\d/
    const phoneCode = document.querySelector(
      '.contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p',
    ).textContent
    const symbol = String.fromCharCode(e.keyCode)
    if (!regex.test(symbol)) {
      e.preventDefault()
    }
    setTimeout(() => {
      document.querySelector('.contactUs--inputPhoneContainer input').value =
        phoneCode + e.target.textContent
    }, 1000)
  })

document
  .querySelector('.contactUs--inputPhoneContainer .contactUs--contentEditable')
  .addEventListener('keydown', function (event) {
    const phoneCode = document.querySelector(
      '.contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p',
    ).textContent

    if (event.key === 'Backspace') {
      setTimeout(() => {
        if (event.target.textContent === '') {
          document.querySelector(
            '.contactUs--inputPhoneContainer input',
          ).value = ''
        } else {
          document.querySelector(
            '.contactUs--inputPhoneContainer input',
          ).value = phoneCode + event.target.textContent
        }
      }, 1000)
    }
  })
